import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ComplianceOverviewStatusSummary } from '../../../compliance-overview/models/compliance-item.model';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-compliance-status-indicator',
  standalone: true,
  imports: [CommonModule, TranslocoDirective],
  templateUrl: './compliance-status-indicator.component.html',
  styleUrl: './compliance-status-indicator.component.scss'
})
export class ComplianceStatusIndicatorComponent {
  @Input({ required: true }) complianceItem!: ComplianceOverviewStatusSummary;
}